const core = {
  // ==================== COMMON ====================
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.back': 'Back',
  'common.close': 'Close',
  'common.search': 'Search',
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.confirm': 'Confirm',
  'common.create': 'Create',
  'common.update': 'Update',
  'common.add': 'Add',
  'common.remove': 'Remove',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.unlimited': 'Unlimited',
  'common.all': 'All',
  'common.none': 'None',
  'common.actions': 'Actions',
  'common.or': 'or',
  'common.copy': 'Copy',
  'common.pleaseWait': 'Please wait a moment',
  'common.noDescription': 'No description',
  'common.username': 'Username',
  'common.password': 'Password',
  'common.email': 'Email',
  'common.description': 'Description',
  'common.name': 'Name',
  'common.status': 'Status',
  'common.category': 'Category',
  'common.price': 'Price',
  'common.currency': 'Currency',
  'common.quantity': 'Quantity',
  'common.unit': 'Unit',
  'common.total': 'Total',
  'common.per': 'per',
  'common.noCategory': 'Uncategorized',
  'common.stock': 'Stock',
  'common.decrease': 'minus',
  'common.increase': 'plus',

  // ==================== LOGIN ====================
  'login.title': 'Sign In',
  'login.subtitle': 'Sign in to manage your procurement.',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.submit': 'Sign In',
  'login.submitting': 'Signing in...',
  'login.fillAllFields': 'Please fill in all fields.',
  'login.checkingSession': 'Checking session...',

  // ==================== HEADER ====================
  'header.administrator': 'Administrator',
  'header.supervisor': 'Supervisor',
  'header.purchaser': 'Purchaser',
  'header.home': 'Back to Home',
  'header.backToCatalogs': 'Back to Catalog Overview',
  'header.newBanf': 'Create New PR',
  'header.banfRequests': 'Purchase Requests',
  'header.banfRequestsDrafts': 'Purchase Requests ({drafts} drafts, {pending} pending)',
  'header.myBanfRequests': 'My Purchase Requests ({count} pending)',
  'header.banfRequestsCostCenter': 'Purchase Requests Cost Center {costCenter} ({count} pending)',
  'header.banfRequestsAll': 'Purchase Requests ({count} pending)',
  'header.adminArea': 'Admin Area',
  'header.settings': 'Settings',
  'header.cart': 'Cart ({count} items)',
  'header.logout': 'Logout',
  'header.backToSap': 'Back to SAP',
  'header.lightMode': 'Enable Light Mode',
  'header.darkMode': 'Enable Dark Mode',
  'header.reloadPage': 'Reload page',
  'header.portalLogoAlt': 'Portal Logo',

  // ==================== FOOTER ====================
  'footer.allRightsReserved': 'All rights reserved.',
  'footer.madeWith': 'Made with',
  'footer.inGermany': 'in Germany',

  // ==================== HOME PAGE ====================
  'home.welcome': 'Welcome, {name}',
  'home.selectModule': 'Select a module to get started',
  'home.procurement': 'Procurement',
  'home.procurementDesc': 'Create purchase requisitions, browse catalogs and manage shopping carts',
  'home.warehouse': 'Warehouse Management',
  'home.warehouseDesc': 'Search stock materials, view inventory and create purchase requisitions',
  'home.einvoicing': 'E-Invoicing',
  'home.einvoicingDesc': 'Capture incoming and outgoing invoices via OCR, run AI-assisted plausibility checks and match them against purchase orders',
  'home.einvoicingBadge': 'ZUGFeRD · KSeF & more compliant',
  'home.plantMaintenance': 'Plant Maintenance',
  'home.plantMaintenanceDesc': 'Manage maintenance orders, maintenance plans and technical objects',
  'home.materialEntry': 'Material Quick Entry',
  'home.materialEntryDesc': 'Quickly capture material master data with reduced fields and transmit it to SAP',
  'home.orderConfirmation': 'Order Confirmation Capture',
  'home.orderConfirmationDesc': 'Capture supplier order confirmations via OCR and AI-check them against the MM purchase order',
  'home.workflowEditor': 'Workflow Editor',
  'home.workflowEditorDesc': 'Define approval processes and connect them with other modules',
  'home.moreModules': 'More Modules',
  'home.moreModulesDesc': 'Additional modules will be added in future updates',
  'home.comingSoon': 'Coming soon',
  'home.moduleLocked': 'Module not licensed',
  'home.userFallback': 'User',

  // ==================== LOGOUT MODAL ====================
  'logout.titleSap': 'Back to SAP',
  'logout.titleLogout': 'Logout',
  'logout.confirmSap': 'Do you really want to go back to SAP?',
  'logout.confirmLogout': 'Do you really want to log out?',
  'logout.cancel': 'Cancel',
  'logout.toSap': 'To SAP',
  'logout.submit': 'Logout',

  // ==================== SETTINGS VIEW ====================
  'settings.title': 'User Settings',
  'settings.profile': 'Profile',
  'settings.security': 'Security',
  'settings.changePassword': 'Change Password',
  'settings.firstName': 'First Name',
  'settings.lastName': 'Last Name',
  'settings.username': 'Username',
  'settings.email': 'Email Address',
  'settings.sapUser': 'SAP User',
  'settings.requester': 'Requester',
  'settings.department': 'Department',
  'settings.costCenter': 'Cost Center',
  'settings.plant': 'Plant',
  'settings.purchasingOrg': 'Purchasing Organization',
  'settings.purchasingGroup': 'Purchasing Group',
  'settings.editProfile': 'Edit Profile',
  'settings.saveChanges': 'Save Changes',
  'settings.cancelEdit': 'Cancel',
  'settings.profileSaved': 'Profile saved successfully!',
  'settings.profileError': 'Error saving profile',
  'settings.currentPassword': 'Current Password',
  'settings.newPassword': 'New Password',
  'settings.confirmPassword': 'Confirm Password',
  'settings.passwordMismatch': 'New passwords do not match',
  'settings.passwordMinLength': 'The new password must be at least 6 characters long',
  'settings.passwordRequired': 'Please enter your current password',
  'settings.passwordChanged': 'Password changed successfully!',
  'settings.passwordError': 'Error changing password',
  'settings.language': 'Language',
  'settings.requiredFields': 'All fields must be filled in. Cost center, plant and purchasing organization must not be empty.',
  'settings.saveError': 'Error saving settings',
  'settings.changeBtn': 'Change',
  'settings.placeholderSapUser': 'e.g. SAP123456',
  'settings.placeholderRequester': 'e.g. John Doe',
  'settings.placeholderCostCenter': 'e.g. 110700',
  'settings.placeholderPlant': 'e.g. 1000',
  'settings.placeholderPurchasingOrg': 'e.g. 001',

  // ==================== APP.JS MESSAGES ====================
  'app.portalLoading': 'Loading portal...',
  'app.unnamed': 'Unnamed Product',
  'app.addedToCart': '"{name}" has been added to cart!',
  'app.shopLoadError': 'Error loading shop products',
  'app.shopSaved': 'Shop saved successfully!',
  'app.errorLoadingShopData': 'Error loading shop data. Please try again.',
  'app.errorAddingToCart': 'Error adding to cart',
  'app.errorCreatingBanf': 'Error creating purchase requisition',
  'app.errorSavingShop': 'Error saving shop',
  'app.errorDeletingShop': 'Error deleting shop.',
  'app.unknownError': 'Unknown error',
  'app.unknownSupplier': 'Unknown Supplier',
  'app.internalShop': 'Internal Shop',

  // ==================== MODULE SCAFFOLD ====================
  'module.inDevelopment': 'Module in Development',
  'module.inDevelopmentDesc': 'This module is currently under development and will be available soon.',

  // ==================== NOTIFICATION BELL ====================
  'notif.title': 'Notifications',
  'notif.empty': 'No new notifications',
  'notif.approvals': 'PRs waiting for your approval',
  'notif.decided': 'Your PRs have been decided',
  'notif.sapErrors': 'SAP transfers failed',
  'notif.drafts': 'Open drafts',
  'notif.settingsTitle': 'Notification settings',
  'notif.settingsHint': 'These switches apply only to you and are saved per user.',
  'notif.swApprovals': 'Pending approvals',
  'notif.swDecided': 'Decisions on my PRs',
  'notif.swSapErrors': 'SAP transfer errors',
  'notif.swDrafts': 'Open drafts',
};

export default core;
